import { useLazyQuery } from '@vue/apollo-composable'
import { FundAssetAllInfoAndOtherPosPageList } from '@/graphql/holdings'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'
import storage, { StorageType } from '@/utils/storage'

export default function useOther() {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(FundAssetAllInfoAndOtherPosPageList)

  onResult((res) => {
    const { extraFundAssetAllInfo, extraPosPageList } = res.data
    if (extraFundAssetAllInfo.ok) {
      store.commit(HoldingsMutationTypes.SET_EXTRA_FUND_ASSET_ALL_INFO, extraFundAssetAllInfo.data)
    }
    if (extraPosPageList.ok) {
      store.commit(HoldingsMutationTypes.SET_EXTRA_POS_PAGE_LIST, extraPosPageList.data)
    }
  })

  const queryOtherData = () => {
    const param = {
      filter: {
        fundAccount: storage.rcGetItem(StorageType.local, 'userInfo')
      },
      filterOther: {
        exchangeType: 'EXTRA',
        fundAccount: storage.rcGetItem(StorageType.local, 'userInfo')
      }
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(FundAssetAllInfoAndOtherPosPageList, param) || refetch(param)
  }
  return { queryOtherData, loading }
}
